import { CURRENCY_CODES, type CurrencyCode } from '@mibodega/shared-types';
import { useCurrencyStore } from '../stores/currencyStore';

export function CurrencySelector() {
  const { currency, setCurrency } = useCurrencyStore();

  return (
    <select
      value={currency}
      onChange={(e) => setCurrency(e.target.value as CurrencyCode)}
      className="rounded-lg border border-neutral-300 px-3 py-1.5 text-sm focus:border-teal-500 focus:outline-none"
    >
      {CURRENCY_CODES.map((c) => (
        <option key={c} value={c}>
          {c}
        </option>
      ))}
    </select>
  );
}
